import { Component, OnInit } from '@angular/core';
declare var $: any;
import * as AOS from 'aos';
import { userInfo } from './user_info';
@ Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})

export class HomePageComponent implements OnInit {
  GettingInfo = [];
  userSocialAccounts = [];
  constructor() {
   }

  ngOnInit() {
    //  initializing AOS
    AOS.init();

    $(document).ready(function (){
      $('a').click(function () {
        var sectionTo = $(this ).attr('href');
        $('html, body').animate({
          scrollTop: $(sectionTo).offset().top
        }, 'slow', function (){

          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = sectionTo;
        });
      });

      // $('#go-to-top').each(function (){
      //   $(this ).click(function (){
      //     $('html').animate({ scrollTop: 0 }, 'slow'); return true;
      //   });
      // });

    });

    // scroll to top
    this .gettingUserInfo();
  }

  //  getting user information
  gettingUserInfo() {
    this .GettingInfo = userInfo.getInfo();
    this .userSocialAccounts = this .GettingInfo[0].user_information;
    // console.log( this .GettingInfo );
    // console.log( this .userSocialAccounts );
  }

}
